import { render, staticRenderFns } from "./recommendedProducts.vue?vue&type=template&id=0e5ac5f2&"
import script from "./recommendedProducts.vue?vue&type=script&lang=js&"
export * from "./recommendedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports